import { Row } from 'react-bootstrap';

import CommonModal from '../../common/modal/CommonModal';
import DetailsView from '../detailsView/DetailsView';

import CannabisLicenseHelper from '../../../helpers/features/CannabisLicensesHelper';

function DetailsModal({ data, handleDetailsModalClose }) {
  return (
    <CommonModal
      className=""
      size="xl"
      title={CannabisLicenseHelper.LICENSE_DETAILS_MODAL_TITLE}
      handleClose={() => handleDetailsModalClose()}
    >
      <Row>
        <DetailsView selectedRowData={data} />
      </Row>
    </CommonModal>
  );
}

export default DetailsModal;
